"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CalculatorEvents;
(function (CalculatorEvents) {
    CalculatorEvents["CONTINUE"] = "continue";
    CalculatorEvents["SAVE"] = "save";
    CalculatorEvents["HAS_NEW_CALCULATION"] = "has new calculation";
})(CalculatorEvents = exports.CalculatorEvents || (exports.CalculatorEvents = {}));
exports.default = CalculatorEvents;
